import { PageLayout } from '@kizi/comparator-core';

const sellingBlocks = {
  type: 'CrossSellingBlockWrapper',
  props: {
    header: 'Bespaar nog meer op...',
    descriptor: [
      {
        type: 'CrossSellingBlock',
        props: {
          title: 'Energievergelijker',
          subtitle: 'Bespaar nu op je energiekosten.',
          link: 'https://www.consumentenbond.nl/energie-vergelijken/?icmp=TPV_bedanktpagina_ev',
          buttonText: 'Vergelijker',
          icon: 'selling-block-energie',
        },
      },
      {
        type: 'CrossSellingBlock',
        props: {
          title: 'Autoverzekering',
          subtitle: 'Bespaar tot €300 per jaar.',
          link: 'https://www.consumentenbond.nl/autoverzekering/?icmp=TPV_bedanktpagina_avv',
          buttonText: 'Stap over',
          icon: 'selling-block-car',
        },
      },
      {
        type: 'CrossSellingBlock',
        props: {
          title: 'Woonverzekering',
          subtitle: 'Stap over en bespaar elke maand.',
          link: 'https://www.consumentenbond.nl/inboedelverzekering/?icmp=TPV_bedanktpagina_wvv',
          buttonText: 'Doe de check',
          icon: 'selling-block-home',
        },
      },
    ],
  },
};

const checkoutLayout: PageLayout = {
  name: 'checkout',
  components: [
    {
      type: 'CheckoutPage',
      props: {
        defaultValues: {
          startdate: 'todaysDate',
        },
        bg: 'second.2',
        contentStyles: {
          width: '1180px',
          maxWidth: '100vw',
          minHeight: '100vh',
          textAlign: 'center',
        },
        content: [
          {
            type: 'CheckoutTopNotificationWrapper',
            props: {
              mt: 6,
              productFieldName: 'overview.selectedProduct',
              title: 'Je aanvraag is afgeleverd bij {dynamicProvider}',
              content: [
                {
                  type: 'P',
                  props: {
                    mb: '0!important',
                    maxWidth: 'unset',
                    variant: 'baseBody',
                    children:
                      'Een bevestiging van je aanvraag is onderweg naar {dynamicEmail}.',
                  },
                },
                {
                  type: 'TextWithLink',
                  props: {
                    children: `<p>We hebben iets nieuws voor je: De <a href="https://www.consumentenbond.nl/mijnconsumentenbond/wallet#/homescreen">Mijn Overstaphulp;</a> dé plek in jouw persoonlijke account waar je een overzicht vindt van je afgesloten contracten en polissen. Let op: de documenten van deze overstap zullen binnen enkele dagen zichtbaar zijn.<br/><br/>Mis je iets? Voeg dan zelf contracten toe. Zo heb je alles overzichtelijk bij elkaar en weet je altijd of je kunt overstappen.</p>`,
                  },
                },
                {
                  type: 'P',
                  props: {
                    maxWidth: 'unset',
                    variant: 'baseBody',
                    children:
                      'Heb je nog vragen? Je bereikt ons telefonisch op werkdagen tussen 9:00 en 18:00 via telefoonnummer (088) 22 66 988 (lokaal tarief).',
                  },
                },
                {
                  type: 'P',
                  props: {
                    maxWidth: 'unset',
                    variant: 'baseBody',
                    children:
                      'Je kunt ook een e-mail sturen naar telecom_vergelijker@voordeelcoach.consumentenbond.nl',
                  },
                },
              ],
            },
          },
          {
            type: 'CheckoutContentBlock',
            props: {
              dependsOn: {
                fieldName: '*.isMember',
                fieldValue: 0,
              },
              my: 6,
              heading: {
                children: 'Zo maak je gebruik van het Basislidmaatschap',
              },
              content: [
                {
                  type: 'P',
                  props: {
                    maxWidth: 'unset',
                    children:
                      'Je ontvangt binnen enkele dagen per e-mail een bevestiging van je lidmaatschap. In deze e-mail vind je ook informatie over het aanmaken van een Consumentenbond-account. Zodra je een account hebt, profiteer je gelijk van alle voordelen.',
                  },
                },
              ],
            },
          },
          sellingBlocks
        ],
        loadingPage: {
          bg: 'second.2',
          contentStyles: {
            width: '1180px',
            maxWidth: '100vw',
            paddingTop: '64px',
          },
          content: [
            {
              type: 'Div',
              props: {
                maxWidth: 700,
                minHeight: '100vh',
                margin: 'auto',
                display: 'flex',
                flexDirection: 'column',
              },
              _children: [
                {
                  type: 'HeadingWithDotsAnimation',
                  props: {
                    variant: 'H2',
                    as: 'h1',
                    title: 'Een momentje graag, je aanvraag wordt verstuurd',
                  },
                },
                {
                  type: 'Div',
                  _children: [
                    {
                      type: 'IconAnimation',
                      props: {
                        iconNames: ['document', 'document'],
                        fill: 'second.1',
                        size: 170,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        errorPage: {
          bg: 'second.2',
          contentStyles: {
            width: '1180px',
            maxWidth: '100vw',
            minHeight: '100vh',
            textAlign: 'center',
          },
          content: [
            {
              type: 'CheckoutTopNotificationWrapper',
              props: {
                mt: 6,
                title: 'Je aanvraag is mislukt',
                heading: {
                  title: 'Je aanvraag is mislukt',
                  icon: {
                    name: 'close',
                    fill: '#FFFFFF',
                  },
                },
                iconBackground: 'supplementary.0',
                content: [
                  {
                    type: 'P',
                    props: {
                      maxWidth: 'unset',
                      variant: 'baseBody',
                      children:
                        'Het is niet gelukt je aanvraag af te ronden. Keer terug naar het overzicht met deals en probeer het opnieuw. Blijft het probleem zich voordoen? Neem dan contact op met onze klantenservice.',
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    },
  ],
};

export default checkoutLayout;
